/**
 * The invented congregation every product shot on this site draws from.
 *
 * Every person here is made up, and that is a hard requirement rather than a
 * courtesy: `15-security.md` keeps real names out of the repo, and a marketing
 * page is the worst possible place to break it — a screenshot of a real roster
 * would be published rather than merely committed.
 *
 * They are shared across the shots on purpose. The same household appears in
 * the members table, on a statement and in a message audience, because the
 * claim the page is making is that they ARE the same record. Three unrelated
 * casts of invented people would quietly demonstrate the opposite.
 */

/** A congregation that does not exist, in a town that does. */
export const DEMO_ORG = {
  name: 'Kehillas Beis Avrohom',
  nameHe: 'קהילת בית אברהם',
  city: 'Lakewood',
  region: 'NJ',
}

export type DemoHousehold = {
  name: string
  nameHe: string
  head: string
  members: number
  since: string
  yichus: 'Kohen' | 'Levi' | 'Yisrael'
}

export const DEMO_HOUSEHOLDS: DemoHousehold[] = [
  {
    name: 'Adler',
    nameHe: 'אדלר',
    head: 'Yaakov Adler',
    members: 6,
    since: '2014',
    yichus: 'Yisrael',
  },
  {
    name: 'Brummer',
    nameHe: 'ברומער',
    head: 'Shimon Brummer',
    members: 4,
    since: '2019',
    yichus: 'Levi',
  },
  {
    name: 'Feldhandler',
    nameHe: 'פלדהנדלר',
    head: 'Dovid Feldhandler',
    members: 9,
    since: '2008',
    yichus: 'Kohen',
  },
  {
    name: 'Kestenbaum',
    nameHe: 'קעסטענבוים',
    head: 'Naftali Kestenbaum',
    members: 3,
    since: '2022',
    yichus: 'Yisrael',
  },
  {
    name: 'Roitman',
    nameHe: 'רויטמאן',
    head: 'Elchonon Roitman',
    members: 7,
    since: '2011',
    yichus: 'Yisrael',
  },
]

/** A yahrzeit falls on a Hebrew date, so it moves against the civil calendar. */
export const DEMO_YAHRZEITS = [
  { forWhom: 'Father of Yaakov Adler', hebrew: 'ט״ז כסלו', civil: '5 Dec' },
  { forWhom: 'Mother of Shimon Brummer', hebrew: 'כ״ב טבת', civil: '10 Jan' },
  { forWhom: 'Father of Elchonon Roitman', hebrew: 'ב׳ שבט', civil: '19 Jan' },
]
